import React from 'react';

import { useFormContext } from 'react-hook-form';

import DefinePropertyDropdown from '$/components/ui/Input/PropertyDropdown';
import { useWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { InteractionInfo } from '../InteractionInfo';
import Form from '$/components/ui/Form';
import { Popup } from '$/components/ui/Popup';
import { BuiltInProperties } from '$/GraphQL/schema/builtInProperties';

export const PropertySettings: React.FC<{
  interaction: InteractionInfo;
  isCreating?: boolean;
  titleFieldName?: string;
}> = ({ interaction, isCreating, titleFieldName }) => {
  const { clearErrors, setError, watch } = useFormContext();
  const { ewebinar, interactions } = useWebinarPlayerContext();

  // exclude reg from fields from dropdown to avoid the issue of overwrite data in attendeeRecord
  const regFormProperties =
    ewebinar.registrationFormSettings.fields
      .filter((f) => f.propertyName)
      .map((f) => f.propertyName) ?? [];
  // also exclude used property by the interactions
  const interactionProps = interactions
    .filter((i) => i.id !== interaction.id)
    .filter((i) => i.propertyName)
    .map((i) => i.propertyName);
  const excludeProperties = regFormProperties.concat(interactionProps).concat(BuiltInProperties);

  return (
    <>
      <div className='flex items-center'>
        <Form.FieldLabel className='mr-0' title='Property name' />
        <Popup
          content={
            <span>
              When you define a property name for an interaction, attendee answers become available
              to your integrations and you can reference the property in other interactions either
              for display or for conditional display of interactions.
              <p />
              You can also map it to custom fields in many of the Integration cards as well as in
              Zapier triggers.
            </span>
          }
          popperModifiers={[
            {
              preventOverflow: {
                enabled: false,
                boundariesElement: 'window',
                escapeWithReference: true,
              },
            },
          ]}
        />
      </div>
      <Form.Field
        className='flex flex-grow'
        name='details.propertyName'
        component={
          <DefinePropertyDropdown
            id='propertyName'
            placeholder='Enter property name (e.g. pollAnswer)'
            onModified={(): void => {
              clearErrors('details.propertyName');
            }}
            onError={(error): void => {
              console.log('ONERROR ', error);
              setError(`details.propertyName`, {
                type: 'Error',
                message: error,
              });
            }}
            excludeProperties={excludeProperties as string[]}
            defaultTitle={titleFieldName ? watch(titleFieldName) : watch('details.title')}
            isCreating={isCreating}
          />
        }
      />
    </>
  );
};
